import { render, staticRenderFns } from "./CurrencyModal.vue?vue&type=template&id=7c971af2&scoped=true&"
import script from "./CurrencyModal.vue?vue&type=script&lang=js&"
export * from "./CurrencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c971af2",
  null
  
)

export default component.exports